import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import getServices from "../../../services/getServices";
import { v4 } from "uuid";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";

const getIPAdress = async () => {
  try {
    const ipAddress = await axiosInstance.get(
      "https://nxt.api.q2pay.in/api/utilities/whatismyip",
    );
    return ipAddress?.data?.ip;
  } catch (error) {
    CommonToast({
      text: error.response.data.errors.base[0],
      icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
      variant: "var(--error)",
      buttonNeeded: false,
    });
  }
};

async function getDeviceInfo() {
  const userAgent = window.navigator.userAgent;
  let browserName = "Unknown";
  let osVersion = "Unknown";

  if (userAgent.indexOf("Edg/") > -1) {
    browserName = "Microsoft Edge (Chromium)";
  } else if (userAgent.indexOf("Chrome") > -1) {
    browserName = "Google Chrome";
  } else if (userAgent.indexOf("Firefox") > -1) {
    browserName = "Mozilla Firefox";
  } else if (userAgent.indexOf("Safari") > -1) {
    browserName = "Apple Safari";
  } else if (
    userAgent.indexOf("MSIE") > -1 ||
    userAgent.indexOf("Trident/") > -1
  ) {
    browserName = "Microsoft Internet Explorer";
  } else if (userAgent.indexOf("Opera") > -1) {
    browserName = "Opera";
  }

  if (/iPhone|iPad|iPod/.test(userAgent)) {
    osVersion = "iOS";
  } else if (/Mac OS X/.test(userAgent) && !/like Mac OS X/.test(userAgent)) {
    osVersion = "macOS";
  } else if (userAgent.indexOf("Windows NT") !== -1) {
    osVersion = "Windows";
  } else if (userAgent.indexOf("Linux") !== -1) {
    osVersion = "Linux";
  } else if (userAgent.indexOf("Android") !== -1) {
    osVersion = "Android";
  }

  const ipAddress = await getIPAdress();

  return {
    uuid: v4(),
    platform: "web",
    browser_name: browserName,
    ip_address: ipAddress,
    os_version: osVersion,
  };
}

export const getRefreshTokenNew = createAsyncThunk(
  "getRefreshTokenNew",
  async (_, { rejectWithValue }) => {
    try {
      const baseUrl = env.REACT_APP_BASE_URL;
      const deviceInfo = await getDeviceInfo();

      const response = await axiosInstance.post(
        `${baseUrl}/me/refresh`,
        { device_info: deviceInfo },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const refreshTokenSlice = createSlice({
  name: "refreshToken",
  initialState: {
    isLoading: false,
    data: null,
    services: null,
    new_services: null,
    sessionStatus: null,
    isError: false,
  },
  reducers: {
    logout: (state, action) => {
      state.isLoading = false;
      state.data = null;
      state.services = null;
      state.sessionStatus = null;
      state.isError = false;
      sessionStorage.setItem("q2p_token", "");
      sessionStorage.removeItem("loggedIn");
      sessionStorage.setItem("tokenGenerated", "false");
    },
    resetServices: (state) => {
      state.isLoading = false;
      state.services = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRefreshTokenNew.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getRefreshTokenNew.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data_new_token = action.payload;
      state.sessionStatus = action.payload?.status;
      sessionStorage.setItem("sessionStatus", state.sessionStatus);
      if (action.payload?.errors) {
      }
      state.data = action.payload;
      state.services = Object?.keys(
        getServices(action?.payload?.services).services_list,
      );
      state.new_services = Object?.keys(
        getServices(action?.payload?.services).services_list,
      );
    });
    builder.addCase(getRefreshTokenNew.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});
export const { logout, resetServices } = refreshTokenSlice.actions;

export default refreshTokenSlice.reducer;
